import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const LinkedinIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 48}
      height={height || 48}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M41.25 5.25H6.75C5.92031 5.25 5.25 5.92031 5.25 6.75V41.25C5.25 42.0797 5.92031 42.75 6.75 42.75H41.25C42.0797 42.75 42.75 42.0797 42.75 41.25V6.75C42.75 5.92031 42.0797 5.25 41.25 5.25ZM16.3734 37.2047H10.8094V19.3078H16.3734V37.2047ZM13.5938 16.8609C12.9559 16.8609 12.3324 16.6718 11.802 16.3174C11.2717 15.9631 10.8583 15.4594 10.6142 14.8701C10.3701 14.2808 10.3063 13.6324 10.4307 13.0068C10.5552 12.3812 10.8623 11.8065 11.3133 11.3555C11.7644 10.9045 12.339 10.5973 12.9646 10.4729C13.5902 10.3485 14.2386 10.4123 14.8279 10.6564C15.4172 10.9005 15.9209 11.3139 16.2752 11.8442C16.6296 12.3746 16.8187 12.9981 16.8187 13.6359C16.8141 15.4172 15.3703 16.8609 13.5938 16.8609ZM37.2047 37.2047H31.6453V28.5C31.6453 26.4234 31.6078 23.7562 28.7531 23.7562C25.8609 23.7562 25.4156 26.0156 25.4156 28.35V37.2047H19.8609V19.3078H25.1953V21.7547H25.2703C26.0109 20.3484 27.825 18.8625 30.5344 18.8625C36.1688 18.8625 37.2047 22.5703 37.2047 27.3891V37.2047Z"
        fill={fillStyle || '#2B2E31'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default LinkedinIcon
